import { FrameDataType } from '@/modules/types/frame';

export type NavSlot = {
  unitTitle?: string;
  frame?: FrameDataType;
};

/** Parses `elearning.units` into a sparse array: each `index#:title` segment sets `units[index] = title`. */
export function parseUnits(unitsString = ''): string[] {
  if (!unitsString) return [];
  const units: string[] = [];
  unitsString.split(';').map((unit) => {
    const [unitIndexString, unitTitle] = unit.split('#:');
    const unitIndex = parseInt(unitIndexString, 10);
    units[unitIndex] = unitTitle;
    return false;
  });
  return units;
}

/**
 * One entry per slot index `i` (length `lastIndex + 1`), matching FrameNav `getSideItems` order:
 * for each `i`, a unit (if any) then a frame (if any) — both may appear on the same slot object.
 */
export function getNavSlots(
  unitsString: string | undefined | null,
  frameData: FrameDataType[] | undefined,
): NavSlot[] {
  let normalized = unitsString;
  if (normalized === undefined || normalized === null) normalized = '';
  if (!frameData) return [];

  const units = parseUnits(normalized);

  const unitLastIndex = units.lastIndexOf(units.slice(-1)[0]);
  const lastIndex =
    unitLastIndex > frameData.length ? unitLastIndex : frameData.length;

  const slots: NavSlot[] = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i <= lastIndex; i++) {
    const slot: NavSlot = {};
    if (units[i]) {
      slot.unitTitle = units[i];
    }
    if (frameData[i]) {
      slot.frame = frameData[i];
    }
    slots.push(slot);
  }
  return slots;
}
